import { render, staticRenderFns } from "./viewport-lazy-render.vue?vue&type=template&id=5dfc4818&lang=pug&"
import script from "./viewport-lazy-render.vue?vue&type=script&lang=js&"
export * from "./viewport-lazy-render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports